package com.upcominds.expedite.dto

import kotlinx.serialization.Serializable

@Serializable
data class SavingsChallengeConfigCreateRequest(
    val targetReductionPercent: Int
)

@Serializable
data class SavingsChallengeConfigDTO(
    val targetReductionPercent: Int
)
